// Layout portale clienti — separato dall'admin.
// Header minimal, footer con contatto supporto, sfondo grigio chiaro.
// Redirect a /portal/login se non autenticato.
import { Outlet, Navigate } from 'react-router-dom'
import { PortalHeader } from './components/PortalHeader'
import { usePortalStore } from './portal.store'
import { Phone, Mail } from 'lucide-react'

export function PortalLayout() {
  const isAuthenticated = usePortalStore((s) => s.isAuthenticated)

  // Redirect al login se non autenticato
  if (!isAuthenticated) {
    return <Navigate to="/portal/login" replace />
  }

  return (
    <div className="flex min-h-screen flex-col bg-gray-50">
      {/* Header fisso */}
      <PortalHeader />

      {/* Contenuto pagina */}
      <main
        id="main-content"
        className="flex-1 px-4 py-8 sm:px-6"
        role="main"
      >
        <div className="mx-auto max-w-5xl">
          <Outlet />
        </div>
      </main>

      {/* Footer con contatto supporto */}
      <footer
        className="border-t border-gray-200 bg-white py-6"
        role="contentinfo"
      >
        <div className="mx-auto flex max-w-5xl flex-col items-center justify-between gap-4 px-4 sm:flex-row sm:px-6">
          <div className="flex items-center gap-3">
            <img src="/logo.png" alt="KleisNote" className="h-10 w-auto" />
            <p className="text-sm text-gray-500">
              KleisNote Portale Clienti &copy; {new Date().getFullYear()}
            </p>
          </div>

          <div className="flex items-center gap-6">
            <a
              href="tel:+390000000000"
              className="flex items-center gap-1.5 text-sm text-gray-500 transition-colors hover:text-[var(--fc-primary)]"
              aria-label="Chiama il supporto"
            >
              <Phone className="h-4 w-4" aria-hidden="true" />
              Supporto
            </a>
            <a
              href="mailto:support@fieldcore.it"
              className="flex items-center gap-1.5 text-sm text-gray-500 transition-colors hover:text-[var(--fc-primary)]"
              aria-label="Email supporto"
            >
              <Mail className="h-4 w-4" aria-hidden="true" />
              support@fieldcore.it
            </a>
          </div>
        </div>
      </footer>
    </div>
  )
}
